import { useState } from 'react';

export interface UseDialogStateReturnType<T = unknown> {
	open: boolean;
	data?: T;
	handleOpen: (data?: T) => void;
	handleClose: () => void;
	toggleDialog: () => void;
}

export const useDialogState = <T = unknown>(
	initialState?: boolean,
	initialData?: T
): UseDialogStateReturnType<T> => {
	const [data, setData] = useState(initialData);
	const [open, setOpen] = useState(initialState || false);
	const [handlers] = useState(() => ({
		handleOpen: (data?: T) => {
			setData(data);
			setOpen(true);
		},
		handleClose: () => {
			setData(initialData);
			setOpen(false);
		},
		toggleDialog: () => {
			setOpen((prev) => !prev);
		},
	}));

	return { data, open, ...handlers };
};
